/**
 * Retrieves the value of a nested property of an object given a string path.
 *
 * @param {Object} obj The object from which to retrieve the value.
 * @param {String} path The dot-separated path to the property.
 *
 * @return {Any} The value of the property at the given path, or undefined if the path does not exist.
 */
const getValueByPath = ( obj, path ) => {
	// Split the path into parts.
	let pathParts = path.split( '.' );

	// Start with the whole object.
	let current = obj;

	// Iterate over each part of the path.
	for ( let i = 0; i < pathParts.length; i++ ) {
		// If the current part has an array index.
		const arrayIndexMatch = pathParts[i].match( /^(\w*)\[(\d+)\](.*)$/ );

		if ( arrayIndexMatch ) {
			// If it does, access the appropriate property and array element.
			const prop = arrayIndexMatch[1];
			const index = parseInt( arrayIndexMatch[2] );
			const remainder = arrayIndexMatch[3];

			if ( prop && typeof current[prop] !== 'undefined' && typeof current[prop][index] !== 'undefined' ) {
				current = current[prop][index];
			} else if ( ! prop && Array.isArray( current ) && typeof current[index] !== 'undefined' ) {
				current = current[index];
			} else {
				// If the property or array element does not exist, return undefined immediately.
				return;
			}

			// If there's more path left (like ".sentence_readable"), handle it in the next iteration.
			if ( remainder ) {
				pathParts.splice( i+1, 0, remainder.slice( 1 ) );  // Slice to remove the leading dot.
			}
			continue;
		}

		if ( typeof current[pathParts[i]] !== 'undefined' ) {
			// If the current property exists, update 'current' to be that property's value.
			current = current[pathParts[i]];
			continue;
		}

		// If the current property does not exist, return undefined immediately.
		return;
	}

	return current;
}

export default getValueByPath;
